import { Reveal } from "@/components/landing/Reveal";
import { ContactForm } from "./ContactForm";
import { WaButton } from "./ui";
import { SITE } from "@/config/site";

export const Contact = () => (
  <section id="contacto" data-testid="contact-section" className="scroll-mt-20 bg-[#0B3C5D] py-16 text-white sm:py-24">
    <div className="mx-auto grid max-w-6xl gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16">
      <Reveal>
        <h2 className="text-[32px] font-extrabold leading-[1.12] tracking-tight sm:text-5xl">¿No sabes qué plan de salud elegir?</h2>
        <p className="mt-5 text-[20px] leading-relaxed text-[#D5E2EA]">Hablemos. Tu asesoría comienza aquí y no tiene costo.</p>
        <WaButton className="mt-8 w-full sm:w-auto" testId="contact-whatsapp-btn" label={`Escribir al ${SITE.whatsappDisplay}`} />
        <p className="mt-4 text-[17px] text-[#D5E2EA]">O si prefieres, déjanos tus datos y te contactamos.</p>
        <img src="/img/salud.webp" alt="Mujer joven sonriendo y mostrando un corazón rojo, símbolo de salud" loading="lazy"
          data-testid="contact-image" className="mt-10 aspect-[3/2] w-full rounded-2xl object-cover object-[center_35%]" />
      </Reveal>
      <Reveal delay={0.1}><ContactForm /></Reveal>
    </div>
  </section>
);
